(function () {
  const $slider = $('.tr-featured-products-slider .trend-products-slider:not(.static1)');

  if (!$slider.length) { return; }

  $slider.slick({
      slidesToScroll: 4,
      slidesToShow: 4,
      arrows: true,
      dots: true,
      rows: 0,
      infinite: true,
      mobileFirst: false,
      prevArrow: '<button type="button" class="slick-prev"></button>',
      nextArrow: '<button type="button" class="slick-next"></button>',
      responsive: [{
          breakpoint: 0, settings: {
              centerMode: true, centerPadding: '65px',
          }
      }, {
          breakpoint: 576, settings: {
              slidesToShow: 1, slidesToScroll: 1,
          }
      }, {
          breakpoint: 768, settings: {
              slidesToShow: 2, slidesToScroll: 1,
          }
      }, {
          breakpoint: 992, settings: {
              slidesToShow: 3, slidesToScroll: 1,
          }
      }, {
          breakpoint: 1200, settings: {
              slidesToShow: 3, slidesToScroll: 1,
          }
      },]
  });
})();